import { useSite } from "@/contexts/SiteContext";
import { Button } from "@/components/ui/button";
import { FileDown } from "lucide-react";

export default function PdfButton({ kind, label = "Audit PDF" }) {
  const { activeSite } = useSite();
  const handle = () => {
    if (!activeSite) return;
    const base = process.env.REACT_APP_BACKEND_URL;
    const url = `${base}/api/export/${kind}/pdf?site_id=${activeSite.id}`;
    window.open(url, "_blank");
  };
  return (
    <Button
      data-testid={`pdf-${kind}-btn`}
      onClick={handle}
      className="h-11 gap-2 bg-ochre-600 hover:bg-ochre-400 text-white"
    >
      <FileDown className="w-4 h-4" />
      {label}
    </Button>
  );
}
